// extracted by mini-css-extract-plugin
export default {"iconHeader":"ModalJustificativaInativacao_iconHeader__eCR43","form":"ModalJustificativaInativacao_form__hok8r"};